import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { adminActions, loginUser, officeAdminLogin } from "../store/adminSlice";
import Alert from "../components/Alert";
import escapeHtml from "../functions/Validator";
import { customerActions, customerLogin } from "../store/customerSlice";
import { staffActions, staffLogin } from "../store/staffSlice";

function SignIn() {
  const dispatch = useDispatch();
  const stateAlert = useSelector((state) => state.admin.alert);
  const customerStateAlert = useSelector(
    (state) => state.customer.customerAlert
  );
  const staffStateAlert = useSelector((state) => state.staff.staffAlert);
  const [data, setData] = useState({ email: "", password: "", role: "1" });
  const [alert, SetAlert] = useState(false);
  const [customerAlert, SetCustomerAlert] = useState(false);
  const [staffAlert, SetStaffAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const signOut = useSelector((state) => state.admin.signOut);
  const navigate = useNavigate();

  // Clear all user state when the component mounts
  useEffect(() => {
    // Clear admin state
    dispatch(adminActions.removeSignout());
    dispatch(adminActions.signOut());
    dispatch(adminActions.removeAlert());

    // Clear customer state
    dispatch(customerActions.removesignout());
    dispatch(customerActions.signout());
    dispatch(
      customerActions.addAlert({
        type: "",
        title: "",
        message: "",
      })
    );

    // Clear staff state
    dispatch(staffActions.removesignout());
    dispatch(staffActions.signout());
    dispatch(
      staffActions.addAlert({
        type: "",
        title: "",
        message: "",
      })
    );

    // Clear local storage
    localStorage.removeItem("adminData");
    localStorage.removeItem("customerData");
    localStorage.removeItem("staffData");
  }, []);

  useEffect(() => {
    if (stateAlert[0] === "success") {
      setIsLoading(false);
      // Check if user is subscribed before navigating
      const adminData = JSON.parse(localStorage.getItem("adminData"));
      if (adminData && adminData.subscribed) {
        navigate("/adminupload?id=12345");
      } else {
        // Show subscription error instead of navigating
        dispatch(adminActions.addAlert({
          type: "unsuccess",
          title: "Subscription Required",
          message: "Your subscription has expired. Please contact admin@sdl.pro to renew."
        }));
        SetAlert(true);
      }
    } else if (stateAlert[0] === "unsuccess") {
      setIsLoading(false);
    }
  }, [stateAlert]);

  useEffect(() => {
    if (customerStateAlert[0] === "success") {
      setIsLoading(false);
      navigate("/customerpendingqoutes");
    } else if (customerStateAlert[0] === "unsuccess") {
      setIsLoading(false);
    }
  }, [customerStateAlert]);

  useEffect(() => {
    if (staffStateAlert[0] === "success") {
      setIsLoading(false);
      navigate("/staffjoblist");
    } else if (staffStateAlert[0] === "unsuccess") {
      setIsLoading(false);
    }
  }, [staffStateAlert]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (data.role === "1") {
      SetAlert(true);
      dispatch(loginUser(data));
    } else if (data.role === "2") {
      SetCustomerAlert(true);
      dispatch(customerLogin(data));
    } else if (data.role === "3") {
      SetStaffAlert(true);
      dispatch(staffLogin(data));
    } else if (data.role === "4") {
      SetAlert(true);
      dispatch(officeAdminLogin(data));
    }

    // Add a timeout to prevent UI from hanging indefinitely
    setTimeout(() => {
      if (isLoading) {
        setIsLoading(false);
      }
    }, 10000); // 10 seconds timeout
  };

  return (
    <div className="w-full min-h-screen bg-white flex flex-col items-center justify-center py-8 px-4">
      <div className="flex flex-col items-center mb-8">
        <img src="/logo-sdl.png" alt="SDL Logo" className="w-24 h-auto mb-4" />
        <h2 className="text-xl font-bold text-gray-800 text-center">
          Welcome to SDL PRO Management
        </h2>
     
      </div>

      <div className="w-full max-w-md bg-white rounded-lg shadow-xl p-6 md:p-8">
        <form
          autoComplete="off"
          noValidate
          onSubmit={handleSubmit}
          className="space-y-6"
        >
          {alert && (
            <Alert
              type={stateAlert[0]}
              title={stateAlert[1]}
              message={stateAlert[2]}
            />
          )}
          {customerAlert && (
            <Alert
              type={customerStateAlert[0]}
              title={customerStateAlert[1]}
              message={customerStateAlert[2]}
            />
          )}
          {staffAlert && (
            <Alert
              type={staffStateAlert[0]}
              title={staffStateAlert[1]}
              message={staffStateAlert[2]}
            />
          )}

          <div className="flex justify-end">
            <p className="text-sm text-gray-600">
              New here?
              <span
                className="ml-1 text-[#66c18a] hover:underline cursor-pointer font-medium"
                onClick={() => navigate("/signup")}
              >
                Sign up
              </span>
            </p>
          </div>

          <div className="space-y-4">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email or Username
              </label>
              <input
                id="email"
                type="email"
                autoComplete="off"
                value={data.email}
                onChange={(e) =>
                  setData({ ...data, email: escapeHtml(e.target.value) })
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] mobile-friendly-input"
                placeholder="Enter username@[company name]"
                required
              />
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Password
              </label>
              <input
                id="password"
                type="password"
                autoComplete="off"
                value={data.password}
                onChange={(e) =>
                  setData({ ...data, password: escapeHtml(e.target.value) })
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] mobile-friendly-input"
                placeholder="Enter your password"
                required
              />
            </div>

            <div>
              <label
                htmlFor="role"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Role
              </label>
              <select
                id="role"
                value={data.role}
                onChange={(e) => setData({ ...data, role: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] mobile-friendly-input"
              >
                <option value="1">Admin</option>
                <option value="2">Customer</option>
                <option value="3">Staff Member</option>
                <option value="4">Office Admin</option>
              </select>
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={isLoading}
              className={`w-full py-2 px-4 ${
                isLoading ? "bg-gray-400" : "bg-[#66c18a] hover:bg-[#59b37d]"
              } text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#66c18a] transition-colors duration-200 mobile-friendly-button`}
            >
              {isLoading ? "Signing In..." : "Sign In"}
            </button>
          </div>

          <div className="text-center">
            <span
              className="text-sm text-[#66c18a] hover:underline cursor-pointer"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot password?
            </span>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SignIn;
